import { Class } from '@tokamakjs/injection';
import { useDiContainer } from '@tokamakjs/react/lib/hooks';

export function useController<T>(Controller: Class<T>): T {
  const container = useDiContainer();
  return container.resolveDepsSync(Controller);
}
